<template>
  <div class="ui container">
    <div class="ui pointing secondary menu">
      <router-link class="item" to="/admin/info">系统信息</router-link>
      <router-link class="item" to="/admin/user">用户管理</router-link>
      <router-link class="item" to="/admin/invitation">邀请管理</router-link>
      <router-link class="item" to="/admin/notification">通知管理</router-link>
      <router-link class="item" to="/admin/menu">菜单管理</router-link>
      <router-link class="item" to="/admin/config">配置管理</router-link>
      <router-link class="item" to="/admin/owhat">OWhat统计</router-link>
      <router-link class="item" to="/admin/weibo">微博配置</router-link>
    </div>

    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'AdminHome'
}
</script>

<style scoped>
.secondary.menu {
  margin-bottom: 6px;
}
</style>
